import actions from './actions'

export default ({ data, option, locationId, inWarehouses, useAlt, altShipping }) => {
  return {

    namespaced: true,

    state: {
      data: data || null,
      option: option || 0,
      locationId: locationId || 0,
      inWarehouses: inWarehouses || [],
      loading: false,
      useAlt: useAlt || false,
      altShipping: altShipping || {
        firstname: null,
        lastname: null,
        address: null,
        city: null,
        zip: null,
        country: App.lang.$t('countries.1')
      }
    },

    mutations: {

      setData (state, { shippingData }) {
        state.data = shippingData
      },

      option (state, shippingOption) {
        state.option = shippingOption
      },

      locationId (state, shippingLocation) {
        state.locationId = shippingLocation
      },

      useAlt (state, useAlt) {
        state.useAlt = useAlt
      },

      altShipping (state, altShipping) {
        state.altShipping = altShipping
      },

      setLoading (state, {loading}) {
        state.loading = loading
      }

    },

    actions,

    getters: {
      altEmpty: ({ altShipping }) => !altShipping.firstname || !altShipping.lastname || !altShipping.zip || !altShipping.city,
      deliveryName: (state) => state.data ? state.data.options[state.option].name : '',
      locationName: (state) => state.data && state.data.options[state.option].name == "Osebni prevzem" ? state.data.options[state.option].locations[state.locationId] : '',
      altAddress: ({ altShipping }) => `${altShipping.address}, ${altShipping.zip} ${altShipping.city}, ${altShipping.country}`,
      userAddress: (s, g, { user }) => `${user.user.address}, ${user.user.zip} ${user.user.city}, ${user.user.country}`,
      deliveryAddress: ({ useAlt }, { altAddress, userAddress, altEmpty }) => useAlt && !altEmpty ? altAddress : userAddress
    }
  }
}
